// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0fcdfc30","703":"8ad63585","787":"cf798564"}[chunkId] + ".chunk.js";
};